module.exports = __webpack_public_path__ + "img/icon-share.09524cb9.svg";